import { render, staticRenderFns } from "./marking.vue?vue&type=template&id=745f43ac&scoped=true"
import script from "./marking.vue?vue&type=script&lang=js"
export * from "./marking.vue?vue&type=script&lang=js"
import style0 from "./marking.vue?vue&type=style&index=0&id=745f43ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f43ac",
  null
  
)

export default component.exports